export function createTriggerId(id) {
    return `${id}-trigger`;
}
export function createContentId(id) {
    return `${id}-content`;
}
export function createItemId(id) {
    return `accordion-item-${id}`;
}
